var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"cover-img"},[_c('ScrollToTopBtn'),_c('TheHeader'),_c('v-main',[_c('router-view')],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }